import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, logEvent, setCurrentScreen, setUserProperties } from 'firebase/analytics';
import { environment } from '../../environments/environment';
import { UtilsResource } from './UtilsResource.resource';
import { TrackEventActionType } from './TrackingManager.resource';


export class GoogleAnalytics {
    static canAnalytics: boolean = false;
    private static analyticsInstance: Analytics | null = null;

    static evaluateCanInitFirebase() {
        const brand = sessionStorage.getItem('brand');
        const brands: any = environment.brands;
        if (!brand || !brands[brand]) {
            return;
        }

        const hasFirebase = brands[brand].config?.hasFirebase;
        if (hasFirebase) {
            this.canAnalytics = true;
        }
    }

    static initFirebase(configFirebase: any) {
        this.evaluateCanInitFirebase();
        
        if (this.canAnalytics) {
            let firebaseConfig = {};

            if (configFirebase) {
                firebaseConfig = configFirebase;
            }

            try {
                const app: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
                this.analyticsInstance = getAnalytics(app);
                return app;
            } catch (error) {
                this.analyticsInstance = null;
                UtilsResource.NSMarkLogError('Error initFirebase analytics', error);
            }
        }
    }

    static sendEventFirebase(eventName: string, category: string, actionGtm: string, label: string, params?:{}) {
        if (this.canAnalytics && this.analyticsInstance) {
            if (actionGtm == TrackEventActionType.NEW_TRACKING) {
                logEvent(this.analyticsInstance, category, params as any);
            } else {
                logEvent(this.analyticsInstance, eventName, {
                    eventGtm: eventName,
                    categoryGtm: category,
                    actionGtm: actionGtm,
                    labelGtm: label
                } as any);
            }
        }
    }

    static setCurrentScreen(namePage: string) {
        if (this.canAnalytics && this.analyticsInstance) {
            setCurrentScreen(this.analyticsInstance, namePage);
        }
    }

    static setCountryUser(country: string) {
        if (this.canAnalytics && this.analyticsInstance) {
            setUserProperties(this.analyticsInstance, { Country: country });
        }
    }

    static clearLocationToAnalytics(tmpLocation: any) {
        try {
            let tmpLoc: any = {};

            tmpLoc.ancestorOrigins = tmpLocation.ancestorOrigins;
            tmpLoc.href = tmpLocation.href;
            tmpLoc.origin = tmpLocation.origin;
            tmpLoc.host = tmpLocation.host;
            tmpLoc.pathname = tmpLocation.pathname;
            tmpLoc.search = tmpLocation.search;

            return tmpLoc;
        } catch (error) {
            UtilsResource.NSMarkLogError('Error clearLocationToAnalytics', error);
        }
    }

}
